import React from 'react';
import ReactDOM from 'react-dom';
import { Amplify } from 'aws-amplify';
import App from './App';
// import amplifyConfig from './aws-exports';
import { Footer } from './components/Footer';
import { Logo } from './components/Logo';

// Amplify.configure(amplifyConfig);
// console.log(amplifyConfig);
// console.log(Amplify.getConfig());



ReactDOM.render(
  <React.StrictMode>
    <App />
    <Logo/>
    <Footer/>
  </React.StrictMode>,
  document.getElementById('root')
);